import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Container,
  Form,
  FormGroup,
} from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { getSettings, updateSetting } from "../../store/settings/actions"

const EditSettings = props => {
  const dispatch = useDispatch()
  const settings = useSelector(state => state.settings.settings)

  useEffect(() => {
    dispatch(getSettings())
  }, [dispatch])
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: (settings && settings.email) || "",
      phone: (settings && settings.phone) || "",
      fb_link: (settings && settings.fb_link) || "",
      insta_link: (settings && settings.insta_link) || "",
      twitter_link: (settings && settings.twitter_link) || "",
      ios_app_link: (settings && settings.ios_app_link) || "",
      android_app_link: (settings && settings.android_app_link) || "",
      version_app: (settings && settings.version_app) || "",
      maintenance_mode: (settings && settings.maintenance_mode) || false,
      force_update: (settings && settings.force_update) || false,
    },

    onSubmit: values => {
      const data = {
        id: settings ? settings.id : 0,
        email: (values && values.email) || "",
        phone: (values && values.phone) || "",
        fb_link: (values && values.fb_link) || "",
        insta_link: (values && values.insta_link) || "",
        twitter_link: (values && values.twitter_link) || "",
        ios_app_link: (values && values.ios_app_link) || "",
        android_app_link: (values && values.android_app_link) || "",
        version_app: (values && values.version_app) || 0,
        maintenance_mode:
          (values && values.maintenance_mode == true ? 1 : 0) || 0,
        force_update: (values && values.force_update == true ? 1 : 0) || 0,
      }

      // update user
      dispatch(updateSetting(data))
    },
  })
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="MENU" breadcrumbItem="Settings" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">General information</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>

                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    className="custom-validation"
                  >
                    {/* <Label>
                      <h4>Social media link</h4>
                    </Label> */}

                    <div className="mb-3">
                      <Label className="form-label">
                        Email<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="email"
                        placeholder="Email"
                        type="email"
                        value={validation.values.email}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Phone<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="phone"
                        placeholder="Phone number"
                        type="text"
                        value={validation.values.phone}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Facebook<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="fb_link"
                        placeholder="Facebook link"
                        type="text"
                        value={validation.values.fb_link}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Twitter<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="twitter_link"
                        placeholder="Twitter Link"
                        type="text"
                        value={validation.values.twitter_link}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Instagram<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="insta_link"
                        placeholder="Instagram link"
                        type="text"
                        value={validation.values.insta_link}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        Android<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="android_app_link"
                        placeholder="Android link"
                        type="text"
                        value={validation.values.android_app_link}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        IOS<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="ios_app_link"
                        placeholder="IOS link"
                        type="text"
                        value={validation.values.ios_app_link}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">
                        App version<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="version_app"
                        placeholder="App version"
                        type="number"
                        value={validation.values.version_app}
                        onChange={validation.handleChange}
                      />
                    </div>
                    <FormGroup switch>
                      <div className="mb-3">
                        <Label className="form-label">
                          Force update
                          <Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="force_update"
                          placeholder="Force update"
                          type="switch"
                          style={{ borderColor: "#0d6efd" }}
                          checked={validation.values.force_update}
                          onClick={v =>
                            validation.setFieldValue(
                              "force_update",
                              !validation.values.force_update
                            )
                          }
                        />
                      </div>
                    </FormGroup>
                    <FormGroup switch>
                      <div className="mb-3">
                        <Label className="form-label">
                          Maintenance mode{" "}
                          <Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="maintenance_mode"
                          placeholder="Maintenance mode"
                          type="switch"
                          style={{ borderColor: "#0d6efd" }}
                          checked={validation.values.maintenance_mode}
                          onClick={v =>
                            validation.setFieldValue(
                              "maintenance_mode",
                              !validation.values.maintenance_mode
                            )
                          }
                        />
                      </div>
                    </FormGroup>

                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="">
                        Submit
                      </Button>{" "}
                      <Button type="reset" color="secondary" className="">
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditSettings
